export const getToken = () => {
    const loginDetails = window.localStorage.getItem('tokendetails');
    const loginDetailsJson = JSON.parse(loginDetails);
    if (loginDetailsJson) {
      const tokenValue = loginDetailsJson.accessToken.jwtToken;
      return tokenValue;
    }
    return null;
  };
  